<template>
	<view class="box">
		<view class="box_list">
			<view class="box_list_item" v-for="(item, index) in 3" :key="index">
				<view class="box_list_item_left">
					<view class="box_list_item_left_a">
						<text>¥</text>
						<text>3</text>
					</view>
					<text class="box_list_item_left_b">满3.01元可用</text>
				</view>
				<view class="box_list_item_right">
					<view class="top">
						<view class="top_a">3元无门槛优惠券1</view>
						<view class="top_b">商城全场通用</view>
						<view class="top_c">
							<text>有效期至 2023-05-11 23:59</text>
							<!-- <image src="@/static/icon/cart_ic_select@2x.png" mode="widthFix"></image> -->
							<image src="@/static/icon/cart_ic_select_grey@2x.png" mode="widthFix"></image>
						</view>
					</view>
					<view class="x"></view>
					<view class="bottom">
						<text>使用规则</text>
						<uni-icons type="bottom" size="15" color="#333333"></uni-icons>
					</view>
				</view>
			</view>
		</view>
		<view class="box_footer">
			<view class="box_footer_btn">确定</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		}
	}
</script>
<style>
	page {
		background-color: #ffffff;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.box_list {
			padding: 24rpx 32rpx;
			box-sizing: border-box;
			.box_list_item {
				width: 100%;
				// height: 236rpx;
				padding: 32rpx 20rpx 18rpx 28rpx;
				box-sizing: border-box;
				background: #FFFFFF;
				border-radius: 12rpx;
				border: 2rpx solid #D20A0A;
				display: flex;
				align-items: center;
				margin-bottom: 16rpx;
				&:last-child {
					margin-bottom: 0 !important;
				}
				.box_list_item_left {
					width: 200rpx;
					height: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-direction: column;
					margin-right: 32rpx;
					.box_list_item_left_a {
						display: flex;
						align-items: center;
						text {
							&:first-child {
								font-size: 36rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #D20A0A;
								margin-top: 35rpx;
							}
							&:last-child {
								font-size: 76rpx;
								font-family: PingFang SC-Semibold, PingFang SC;
								font-weight: 600;
								color: #D20A0A;
							}
						}
					}
					.box_list_item_left_b {
						font-size: 24rpx;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #D20A0A;
						margin-top: 24rpx;
					}
				}
				.box_list_item_right {
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.top {
						display: flex;
						flex-direction: column;
						.top_a {
							font-size: 32rpx;
							font-family: PingFang SC-Medium, PingFang SC;
							font-weight: 500;
							color: #333333;
						}
						.top_b {
							font-size: 20rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #999999;
							margin-top: 20rpx;
						}
						.top_c {
							margin-top: 20rpx;
							display: flex;
							align-items: center;
							justify-content: space-between;
							text {
								font-size: 20rpx;
								font-family: PingFang SC-Regular, PingFang SC;
								font-weight: 400;
								color: #999999;
							}
							image {
								width: 32rpx;
								height: 32rpx;
							}
						}
					}
					.x {
						width: 100%;
						height: 2rpx;
						background-color: #F4F5F4;
						margin: 24rpx 0 10rpx 0;
					}
					.bottom {
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							font-size: 20rpx;
							font-family: PingFang SC-Regular, PingFang SC;
							font-weight: 400;
							color: #333333;
						}
					}
				}
			}
		}
		.box_footer {
			position: fixed;
			left: 0;
			bottom: 0;
			width: 100%;
			box-sizing: border-box;
			padding: 12rpx 54rpx calc(12rpx + env(safe-area-inset-bottom)) 54rpx;
			.box_footer_btn {
				width: 100%;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				background: linear-gradient(270deg, #D20A0A 0%, #D95A5A 100%);
				border-radius: 36rpx;
				font-size: 32rpx;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
			}
		}
	}
</style>